import { CdcDepositCardService } from '@cronos-app/binding-swap-sdk';
import type { ChainId_L1, ChainLayer } from '@cronos-app/sdk';
import { ChainId, getChainOfLayer } from '@cronos-app/sdk';
import { currentWallet } from '@cronos-app/wallet';

import { useCardLayer } from '../useCardContextStore';

const cache = new Map<string, CdcDepositCardService | undefined>();

export const getCdcDepositCardService = (
  network: ChainId_L1,
  layer: ChainLayer,
) => {
  const chainId = +getChainOfLayer(network, layer);
  const cacheKey = [chainId].join('-');
  let service = cache.get(cacheKey);
  if (!service) {
    service = new CdcDepositCardService(
      chainId,
      true,
      network === ChainId.SEPOLIA
        ? 'ef3d1e964f574dbeb926b8ddce6f3469' // cronos testnet
        : '691591b58eea469a86c2ea6c7b75659d', // cronos mainnet
    );
    cache.set(cacheKey, service);
  }
  return service;
};

export const useCdcDepositCardService = () => {
  const layer = useCardLayer();
  const network = currentWallet.useDesiredNetwork();
  return getCdcDepositCardService(network, layer);
};
